import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import InviteUser from 'src/components/header/inviteUser/InviteUser';
import { assignModalId } from 'src/store/common/common.slice';

import { ActionCard } from '../actionCard';
import { useNavigate } from 'react-router-dom';
import { ConfirmModal } from 'src/components/common';
import { useEffect, useState } from 'react';
import { topFeedItems } from 'src/store/socialMedia/socialMedia.slice';

export const inviteUserModalId = 'inviteUserModal';

const InviteNetwork = () => {
  // Hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const { modalId } = useAppSelector((store: any) => store.common);
  const isAuthorized: boolean = useAppSelector((store: any) => store.auth.isAuthorized);
  const { topUsersCompany } = useAppSelector((store) => store.socialMedia);
  const topUsers = topUsersCompany?.inviteConnections?.slice(0, 3);

  const [show, setShow] = useState<boolean>(false)

  // Constants
  const openInviteUserModal = modalId === inviteUserModalId;

  const handleOpenInviteUserModal = () => {
    if (isAuthorized) {
      dispatch(assignModalId(inviteUserModalId));
    } else {
      setShow(true)
    }
  };

  const handleCloseInviteUserModal = () => {
    dispatch(assignModalId(''));
  };
  function handleNavigate() {
    navigate('/login?prev=/dashboard')
  }

  useEffect(() => {
    if (topUsers?.length === 0) {
      dispatch(topFeedItems())
    }
  }, [])

  return (
    <>
      <ActionCard
        className="invite-network-component"
        title="Invite Connections"
        description="Connect to ignite ideas, build and scale startups"
        buttonText="Invite Your Network"
        onClick={handleOpenInviteUserModal}
      />
      {openInviteUserModal && (
        <InviteUser isModalOpen={openInviteUserModal} closeModal={handleCloseInviteUserModal} />
      )}
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
    </>
  );
};

export default InviteNetwork;
